import React from "react";
import {
  Modal,
  Box,
  Typography,
  Divider,
  CardContent,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import BadgeIcon from "@mui/icons-material/Badge";
import PhoneIcon from "@mui/icons-material/Phone";
import SmartphoneIcon from "@mui/icons-material/Smartphone";
import EmailIcon from "@mui/icons-material/Email";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import PersonIcon from "@mui/icons-material/Person";
import CreditScoreIcon from "@mui/icons-material/CreditScore";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";

const UserProfileModal = ({ open, handleClose, loggeduserdetail }) => {
  if (!loggeduserdetail) return null;

  const availableCredits =
    loggeduserdetail.locationCredit - loggeduserdetail.lcreditUsed;

  const userFields = [
    { label: "Name", value: loggeduserdetail.userFullName, icon: <AccountCircleIcon /> },
    { label: "Designation", value: loggeduserdetail.userDesignation, icon: <BadgeIcon /> },
    { label: "Telephone", value: loggeduserdetail.userPhone, icon: <PhoneIcon /> },
    { label: "Mobile", value: loggeduserdetail.userMobile, icon: <SmartphoneIcon /> },
    { label: "Email", value: loggeduserdetail.userEmail, icon: <EmailIcon /> },
    { label: "Account Title", value: loggeduserdetail.userAccTitle, icon: <AccountBoxIcon /> },
    { label: "Username", value: loggeduserdetail.userName, icon: <PersonIcon /> },
    { label: "Total Credits", value: loggeduserdetail.locationCredit, icon: <CreditScoreIcon /> },
    { label: "Available Credits", value: availableCredits, icon: <MonetizationOnIcon /> },
  ];

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 420,
          bgcolor: "background.paper",
          boxShadow: 24,
          borderRadius: 2,
          p: 3,
        }}
      >
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Typography variant="h6">User Profile</Typography>
          <IconButton onClick={handleClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>

        <Divider sx={{ mb: 2 }} />

        <CardContent>
          {userFields.map(
            (field, index) =>
              field.value && (
                <Box
                  key={index}
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  mb={1.5}
                >
                  <Box display="flex" alignItems="center">
                    <Box mr={1} color="primary.main">
                      {field.icon}
                    </Box>
                    <Typography variant="subtitle2" color="text.secondary">
                      {field.label}
                    </Typography>
                  </Box>
                  <Typography variant="body2" sx={{ textAlign: "right", ml: 2 }}>
                    {field.value}
                  </Typography>
                </Box>
              )
          )}
        </CardContent>
      </Box>
    </Modal>
  );
};

export default UserProfileModal;
